import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import ProfileHeader from "../components/ProfileHeader";
import ResumeSection from "../components/ResumeSection";
import EducationSection from "../components/EducationSection";
import KeySkillsSection from "../components/KeySkillsSection";
import ExperienceSection from "../components/ExperienceSection";
import ProjectsSection from "../components/ProjectsSection";
import InternshipsSection from "../components/InternshipsSection";
import PreferencesSection from "../components/PreferencesSection";
import LanguagesSection from "../components/LanguagesSection";
import CertificationsSection from "../components/CertificationsSection";
import "../styles/candidatedetailprofile.css"
import axios from "axios";
import { useNavigate } from "react-router-dom";
//const userId = 9; // Example user ID, replace with actual user ID logic

const SECTIONS = [
  "Resume",
  "Education",
  "Key Skills",
  "Experience",
  "Projects",
  "Internships",
  "Preferences",
  "Languages",
  "Certifications & Achievements",
];

const INITIAL = {
  headerName: "",
  headerQualification: "",
  headerSpecialization: "",
  headerMobile: "",
  // headerDomain: "",
  experience: 0,
  gender: "",
  resume: null,
  education: [],
  skills: [],
  projects: [],
  internships: [],
  preferences: {},
  languages: [],
  certifications: [],
};

function Candidatedetailprofile() {
  const navigate = useNavigate()
  const [profile, setProfile] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("detailed_profile_v2")) || INITIAL;
    } catch {
      return INITIAL;
    }
  });

  {/*useEffect(() => {
    localStorage.setItem("detailed_profile_v2", JSON.stringify(profile));
  }, [profile]);*/}
  // added this code in 20-11-2025
  {/*useEffect(() => {
    async function fetchProfile() {
      try {
        const response = await axios.get(
          "http://144.91.102.67:8001/api/candidate/profile"
        );

        // added on 3-12-2025

        // ADDED ON NEW 
        const data = response.data;

        // 🔥 FIX — Convert backend resume URL into full URL
        if (data.resume && data.resume.url) {
          data.resume.url = "http://144.91.102.67:8001" + data.resume.url; // 🔥 FIX
        }

        //setFormData(response.data);
        setProfile(response.data);
      } catch (error) {
        console.error("Error loading profile:", error);
      }
    }

    fetchProfile();
  }, [userId]);*/}

  //added for API integration with token wise on 9-12-2025
  useEffect(() => {
  async function fetchProfile() {
    try {
      const token = localStorage.getItem("access_token");
      console.log("TOKEN IN PROFILE PAGE:", token);

      if (!token) {
        alert("User not logged in");
        navigate("/");
        return;
      }

      const response = await axios.get(
        "http://144.91.102.67:8002/api/candidate/profile",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // added on 11-12-2025 for resume url fix
      const data = response.data;
      if (data.resume && data.resume.url) {
        data.resume.url = "http://144.91.102.67:8002" + data.resume.url;
      }

      console.log("PROFILE RESPONSE:", response.data);
      //setProfile(response.data);
      setProfile(data);

    } catch (error) {
      console.error("❌ Error loading profile:", error);
      //alert("Unable to load profile, please login again.");
      //navigate("/");
    }
  }

  fetchProfile();
}, []);


  const update = (patch) => setProfile((p) => ({ ...p, ...patch }));

  const calcScore = (p) => {
    let s = 10;
    if (p.resume) s += 15;
    if (p.education && p.education.length > 0) s += 10;
    if (p.skills && p.skills.length >= 1) s += 15;
    if (p.experienceData && p.experienceData.length > 0) s += 10;
    if (p.projects && p.projects.length > 0) s += 7;
    if (p.internships && p.internships.length > 0) s += 10;
    if (p.preferences.domain || (p.preferences.locations?.length)) s += 8;
    if (p.languages.length) s += 5;
    if (p.certifications.length) s += 10;
    return Math.min(100, s);
  };


  const score = calcScore(profile);

  {/*const simulateParseResume = (file) => ({
    resume: { name: file.name, size: file.size },
    headerName: "Pavithra K",
    headerQualification: "B.E.",
    headerSpecialization: "Computer Science",
    gender:"Female",
    headerMobile: "1234567898",
    headerDomain: "Software Development",
    experience: 2,
    education: [
      { course: "B.Tech", specialization: "Computer Science", institute: "GCE Krishnagiri", startYear: "2021", endYear: "2025" },
    ],
    skills: ["React", "Node.js", "MySQL"],
    projects: [{ title: "Portfolio Site", domain: "Frontend" }],
    internships: [{ company: "DLK Tech", role: "Intern", start: "2024-06", end: "2024-07" }],
    preferences: { domain: "Software", locations: ["Chennai", "Remote"] },
    languages: ["English", "Tamil"],
    certifications: [{ name: "React Basics", start: "2023-01", end: "2023-03" }],
  });

  const handleResumeUpload = (file) => {
    const parsed = simulateParseResume(file);
    setProfile((p) => ({ ...p, ...parsed }));
    alert("Resume parsed successfully!");
  };*/}
  const handleResumeUpload = async (file) => {
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const token = localStorage.getItem("access_token");
      const res = await axios.post(
        "http://144.91.102.67:8002/api/candidate/upload_resume",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          }
        }
      );
      // added on resume showing after upload 3-12-2025
      // 🔥 FIX — backend returns /static/... so convert to full URL
      const fullUrl = "http://144.91.102.67:8002" + res.data.resume_url; // 🔥 FIX

      setProfile((prev) => ({
        ...prev,
        resume: { url: fullUrl }
      }));

      alert("Resume uploaded successfully!");

    } catch (err) {
      console.error(err);
      alert("Resume upload failed!");
    }
  };

  {/*const saveProfile = async () => {
    try {
      await axios.put(
        "http://144.91.102.67:8001/api/candidate/profile/update",
        profile
      );
      alert("Profile saved successfully!");
      //navigate("/jobs")
    } catch (err) {
      console.error("Save error:", err);
      alert("Failed to save profile");
      console.log(JSON.stringify(profile, null, 2));
    }
  };*/}

  // added on 11-12-2025 for token common intergration

  const saveProfile = async () => {
  try {
    const token =
      localStorage.getItem("access_token");

    if (!token) {
      alert("User not logged in!");
      return;
    }

    await axios.put(
      "http://144.91.102.67:8002/api/candidate/profile/update",
      profile,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );

    alert("Profile saved successfully!");
  } catch (err) {
    console.error("Save error:", err);
    alert("Failed to save profile");
    console.log(JSON.stringify(profile, null, 2));
  }
};


  return (
    <div className="app-root">
      <header className="cheader">
        <ProfileHeader
          name={profile.headerName}
          // domain={profile.headerDomain}
          experience={profile.experience}
          qualification={profile.headerQualification}
          specialization={profile.headerSpecialization}
          gender={profile.gender}
          mobile={profile.headerMobile}
          score={score}
        />
      </header>

      <div className="layout">
        <Sidebar
          sections={SECTIONS}
          onSelect={(s) => {
            const id = "section-" + s;
            const el = document.getElementById(id);
            if (el) el.scrollIntoView({ behavior: "smooth" });
          }}
        />

        <main className="main">
          <div id="section-Resume">
            <ResumeSection
              value={profile.resume}
              onUpload={handleResumeUpload}
              onRemove={() => update({ resume: null })}
            />
          </div>

          <div id="section-Education">
            <EducationSection value={profile.education} onChange={(v) => update({ education: v })} />
          </div>

          <div id="section-Key Skills">
            <KeySkillsSection value={profile.skills} onChange={(v) => update({ skills: v })} />
          </div>
          <div id="section-Experience">
            <ExperienceSection
              value={profile.experienceData}
              onChange={(v) => update({ experienceData: v })}
              onYearsChange={(yrs) => update({ experience: yrs })}
            />
          </div>

          <div id="section-Projects">
            <ProjectsSection value={profile.projects} onChange={(v) => update({ projects: v })} />
          </div>

          <div id="section-Internships">
            <InternshipsSection value={profile.internships} onChange={(v) => update({ internships: v })} />
          </div>

          <div id="section-Preferences">
            <PreferencesSection value={profile.preferences} onChange={(v) => update({ preferences: v })} />
          </div>

          <div id="section-Languages">
            <LanguagesSection value={profile.languages} onChange={(v) => update({ languages: v })} />
          </div>

          <div id="section-Certifications & Achievements">
            <CertificationsSection value={profile.certifications} onChange={(v) => update({ certifications: v })} />
          </div>
          <div className="final_save">
            <button className="f_discard" onClick={() => navigate("/candidate-dashboard")}>Discard</button>
            <button className="f_save" onClick={saveProfile} >Save All</button>
          </div>
        </main>
      </div>
      
    </div>
  );
}
export default Candidatedetailprofile